import { SetStateAction, useEffect, useState } from 'react';
import { Modal } from '@zeeve-platform/modal-component';
import { Button } from '@zeeve-platform/button-component';
import { Inputbox } from '@zeeve-platform/inputbox-component';
import { Breadcrumb } from '@zeeve-platform/breadcrumb-component';
import cloudselect from '../../../images/cloud-select1.png';
import cloudselect2 from '../../../images/cloud-select3.png';
import polkadotLogo from '../../../images/Polkadot_Logo2.svg';
import tencentCloud from '../../../images/tencent.svg';
import aws from '../../../images/AWS.png';
import Loading from '../../../components/common/loader';
import Urls from '../../../utils/util';
import {
  getPlansData,
  createSubscription,
} from '../../../services/apisService';

interface protocolInfo {
  plan: {
    code: string;
    price: number;
  };
  addOnCodes: {
    code: string;
    price: number;
  }[];
}

interface Props {
  purchaseType: string;
}

const DedicatedNodeBody = ({ purchaseType }: Props) => {
  const getCodeFromConfig = (code: string) => Urls.getItemCode(code);
  const [protocolData, setProtocolData] = useState({} as protocolInfo);
  const [managedHosting, setManagedHosting] = useState(false);
  const [cloudInfra, setCloudInfra] = useState('');
  const [nodeType, setNodeType] = useState('');
  const [nodeCost, setNodeCost] = useState<number>(0);
  const [nodeCount, setNodeCount] = useState<number>(1);
  const [infraType, setInfraType] = useState<number>(0);
  const [showLoader, setShowLoader] = useState<boolean>(true);
  const [btnDisable, setBtnDisable] = useState<boolean>(false);
  const [dataLoaded, setDataLoaded] = useState<boolean>(false);
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [redirectionUrl, setRedirectionUrl] = useState<string>('');
  const [purchaseResMsg, setPurchaseResMsg] = useState<string>('');
  const [totalCost, setTotalCost] = useState<number>(0);

  const NodeTypes = [
    {
      name: 'Full',
      code: 'NODE_FULL',
      disable: false,
      description: 'Full node type for syncing chain of Polkadot.',
    },
    {
      name: 'Validator',
      code: 'NODE_STAKING',
      disable: false,
      description: 'Validator node type for syncing chain of Polkadot.',
    },
  ];
  const paths = [
    {
      name: 'Dashboard',
      path: Urls.getDashboardUrl(),
    },
    {
      name: purchaseType === 'dedicatedNode' ? 'Dedicated Full Nodes' : 'Dedicated Validator Nodes',
      path: purchaseType === 'dedicatedNode' ? Urls.getAllNetworkUrl() : Urls.getStakingNetworksUrl(),
    },
    {
      name: 'Select Subscription',
      path: purchaseType === 'dedicatedNode' ? Urls.getMarketplaceUrl() : Urls.getStakingMarketplaceUrl(),
    },
  ];

  const getCostByCode = (code: string) => {
    if (protocolData && protocolData.addOnCodes) {
      const priceChart = protocolData.addOnCodes;
      const isCodePresent = priceChart.find((o) => o.code === code);
      if (isCodePresent) {
        return isCodePresent?.price;
      }
      return 0;
    }
    return 0;
  };

  const getPlanDetails = async () => {
    setShowLoader(true);
    const response: any = await getPlansData();
    setShowLoader(false);
    if (response && response.data) {
      setProtocolData(response.data);
      setNodeCost(response.data.plan.price);
      setDataLoaded(true);
    } else {
      setNodeCost(0);
      setShowLoader(false);
      setDataLoaded(false);
    }
  };

  useEffect(() => {
    getPlanDetails();
    if (window.location.pathname.includes('full')) {
      setNodeType(getCodeFromConfig(NodeTypes[0].code));
    } else {
      setNodeType(getCodeFromConfig(NodeTypes[1].code));
    }
  }, []);

  useEffect(() => {
    hideMessage();
    calculateCost();
  }, [cloudInfra, nodeType, nodeCount]);

  const showMessage = (msg: string) => {
    const ptag = document.getElementById('etag');
    if (ptag) {
      ptag.style.display = 'block';
      ptag.innerHTML = msg;
    }
  };
  const hideMessage = () => {
    const ptag = document.getElementById('etag');
    if (ptag) {
      ptag.style.display = 'none';
    }
  };
  const calculateCost = () => {
    if (!protocolData || !protocolData.plan || !protocolData.plan.price) {
      return 0;
    }

    let cloudCost = 0;
    let nodeTypeCost = 0;
    if (cloudInfra) cloudCost = getCostByCode(cloudInfra);
    if (nodeType) nodeTypeCost = getCostByCode(nodeType);
    setNodeCost(protocolData?.plan?.price + cloudCost + nodeTypeCost || 0);
    setTotalCost(
      (protocolData?.plan?.price + cloudCost + nodeTypeCost) * nodeCount,
    );
    return null;
  };
  const nodeCountHandler = (value: string) => {
    if ((parseInt(value, 10) > 0) && (parseInt(value, 10) < 101)) {
      setNodeCount(parseInt(value, 10));
    } else if ((parseInt(value, 10) < 1)) {
      showMessage('Number of nodes cannot be less than 1.');
    } else if ((parseInt(value, 10) > 100)) {
      showMessage('Number of nodes cannot be more than 100.');
    }
  };
  const setCloudCode = (val: string) => {
    setCloudInfra(getCodeFromConfig(val));
  };
  const checkStakingOrDedicated = (): string => {
    if (window.location.pathname.includes('full')) {
      return 'dedicatedNodes';
    }
    return 'stakingNodes';
  };
  const validate = () => {
    if (
      dataLoaded
      && cloudInfra
      && cloudInfra.length > 0
      && nodeType
      && nodeType.length > 0
      && nodeCount > 0
      && nodeCount <= 100
    ) {
      hideMessage();
      return true;
    }
    if ((!cloudInfra || cloudInfra.length < 1) && infraType === 0) {
      showMessage('Please select cloud type.');
      return false;
    }
    if ((!cloudInfra || cloudInfra.length < 1) && infraType === 1) {
      showMessage('Please select cloud.');
      return false;
    }
    if (!cloudInfra) {
      showMessage('Please select cloud type.');
      return false;
    }

    if (!nodeCount || nodeCount <= 0) {
      showMessage('Number of nodes cannot be less than 1.');
      return false;
    }
    if (nodeCount > 100) {
      showMessage('Number of nodes cannot be more than 100.');
      return false;
    }
    if (!protocolData || !protocolData.plan || !protocolData.plan.price) {
      showMessage('Please try after some time.');
      return false;
    }
    return false;
  };
  const buyPlan = async () => {
    if (!validate()) {
      return;
    }
    setBtnDisable(true);
    setShowLoader(true);
    const codesArr = [];
    if (cloudInfra !== 'NOCODE') {
      codesArr.push(cloudInfra);
    }
    if (nodeType !== 'NOCODE') {
      codesArr.push(nodeType);
    }

    const data = {
      quantity: nodeCount,
      addOnCodes: codesArr,
      planCode: protocolData.plan.code,
    };
    const typeOfNode: string = checkStakingOrDedicated();
    const response: any = await createSubscription(
      { ...data },
      typeOfNode,
    );
    setBtnDisable(false);
    setShowLoader(false);
    if (response) {
      setModalShow(true);
      if (response.success) {
        setPurchaseResMsg(response.data.message);
        setRedirectionUrl(response.data.redirectionUrl);
      } else {
        setPurchaseResMsg(response.message);
      }
    } else {
      setPurchaseResMsg('Error request failed');
      setModalShow(false);
    }
  };
  const continueNext = () => {
    window.open(redirectionUrl, '_self');
  };

  // Cloud type by default selected for Zeeve Managed Cloud
  useEffect(() => {
    if (!Urls.isByocEnabled()) {
      setManagedHosting(true);
      setInfraType(2);
      setCloudCode('ZEEVE_MANAGED');
    }
  }, []);

  // Cloud type by default selected for Zeeve Managed Cloud
  useEffect(() => {
    calculateCost();
  }, [dataLoaded]);

  return (
    <section className="px-5 col-12">
      <div className="mt-5 col-11 mx-auto">
        <div className="row">
          <div className="col-xl-8 col-lg-8 col-sm-12 mx-auto">
            <div className="col-4">
              <img src={polkadotLogo} alt="polkadot-logo" width="130px" />
            </div>
            <div className="mt-2">
              <Breadcrumb
                prefixLink={paths}
                activeLink="Purchase"
                textSize={13}
              />
            </div>
            <div className="mt-5">
              <h5>
                <b>Select Subscription Options</b>
              </h5>
              <label htmlFor="z21" className="mt-4" style={{ fontWeight: 700 }}>
                Select Cloud Type
              </label>
              <div className="row mt-3 radioleft">
              {Urls.isByocEnabled() && (
                <div className="form-check col-xl-5 col-lg-5 col-lg-6 col-sm-12">
                  <Inputbox
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault15"
                    id="z21"
                    onChange={() => {
                      setManagedHosting(false);
                      setInfraType(1);
                      setCloudInfra('');
                    }}
                  />
                  <label className="form-check-label mx-2" htmlFor="z21">
                    Bring Your Own Cloud
                    <i
                      title="Configure your own cloud account for hosting of your node."
                      className="mx-2 fa fa-info-circle"
                    />
                  </label>
                </div>
              )}
                <div className="form-check col-xl-5 col-lg-5 col-lg-6 col-sm-12">
                  <Inputbox
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault15"
                    id="flexRadioDefault15"
                    onChange={() => {
                      setManagedHosting(true);
                      setInfraType(2);
                      setCloudCode('ZEEVE_MANAGED');
                    }}
                    checked={!Urls.isByocEnabled() || infraType === 2}
                  />
                  <label
                    className="form-check-label mx-2"
                    htmlFor="flexRadioDefault15"
                  >
                    Zeeve Managed Cloud
                    <i
                      title="Choose Zeeve's managed hosting for infrastructure of your node."
                      className="mx-2 fa fa-info-circle"
                    />
                  </label>
                </div>
              </div>
              {Urls.isByocEnabled() && infraType === 1 && !managedHosting && (
                <div className="cursor">
                  <div className="row mt-4">
                    <div className="col-xl-2 col-lg-2 col-md-5 col-sm-5 mx-0">
                      <div className="cloud-select">
                        <span className="d-flex justify-content-end">
                          <Inputbox
                            className="form-check-input"
                            type="radio"
                            name="cloudAccount"
                            id="z22"
                            value="BYOC_AWS"
                            onChange={(e: { target: { value: string } }) => {
                              setCloudCode(e.target.value);
                            }}
                          />
                        </span>
                        <div className="text-center pt-4 pb-2">
                          <img src={aws} alt="" />
                          <p className="text-muted">AWS</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-2 col-lg-2 col-md-5 col-sm-5 mx-0">
                      <div className="cloud-select">
                        <span className="d-flex justify-content-end">
                          <Inputbox
                            className="form-check-input"
                            type="radio"
                            name="cloudAccount"
                            id="checkboxNoLabel"
                            value="BYOC_DIGITAL_OCEAN"
                            onChange={(e: { target: { value: string } }) => {
                              setCloudCode(e.target.value);
                            }}
                          />
                        </span>
                        <div className="text-center pt-4 pb-3">
                          <img src={cloudselect} alt="" />
                          <p className="text-muted">Digital Ocean</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-2 col-lg-2 col-md-5 col-sm-5 mx-0">
                      <div className="cloud-select">
                        <span className="d-flex justify-content-end">
                          <Inputbox
                            className="form-check-input"
                            type="radio"
                            name="cloudAccount"
                            id="checkboxNoLabel"
                            value="BYOC_GCP"
                            onChange={(e: { target: { value: string } }) => {
                              setCloudCode(e.target.value);
                            }}
                          />
                        </span>
                        <div className="text-center pt-4 pb-3">
                          <img
                            src={cloudselect2}
                            alt=""
                          />
                          <p className="text-muted">GCP</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-2 col-lg-2 col-md-5 col-sm-5 mx-0">
                      <div className="cloud-select">
                        <span className="d-flex justify-content-end">
                          <Inputbox
                            className="form-check-input"
                            type="radio"
                            name="cloudAccount"
                            id="checkboxNoLabel"
                            value="BYOC_TENCENT"
                            onChange={(e: { target: { value: string } }) => {
                              setCloudCode(e.target.value);
                            }}
                          />
                        </span>
                        <div className="text-center pt-4 pb-3">
                          <img
                            src={tencentCloud}
                            alt=""
                          />
                          <p className="text-muted">Tencent Cloud</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {showLoader && <Loading />}
            <div className="mt-4 col-12">
              <label
                htmlFor={`custom-radio-syncmode-${0}`}
                style={{ fontWeight: 700 }}
              >
                Select Node Type
              </label>
              <div className="row mt-3 mx-2">
              {purchaseType === 'dedicatedNode' ? (
                <div className="form-check col-xl-2 col-lg-2 col-sm-2 col-md-2">
                  <Inputbox
                    name="syncMode"
                    type="radio"
                    className="form-check-input"
                    id={`custom-radio-syncmode-${0}`}
                    disabled={NodeTypes[0].disable}
                    checked="checked"
                    value={getCodeFromConfig(NodeTypes[0].code)}
                    onChange={(e: {
                      target: { value: SetStateAction<string> };
                    }) => {
                      setNodeType(e.target.value);
                    }}
                  />
                  <label
                    className="form-check-label mx-2"
                    htmlFor={`custom-radio-syncmode-${0}`}
                  >
                    {NodeTypes[0].name}
                    <i
                      title={NodeTypes[0].description}
                      className="mx-2 fa fa-info-circle"
                    />
                  </label>
                </div>
              ) : (
                <div className="form-check col-xl-6 col-lg-6 col-sm-6 col-md-6">
                  <Inputbox
                    name="syncMode"
                    type="radio"
                    className="form-check-input"
                    id={`custom-radio-syncmode-${1}`}
                    value={getCodeFromConfig(NodeTypes[1].code)}
                    checked="checked"
                    onChange={(e: {
                      target: { value: SetStateAction<string> };
                    }) => {
                      setNodeType(e.target.value);
                    }}
                  />
                  <label
                    className="form-check-label mx-2"
                    htmlFor={`custom-radio-syncmode-${1}`}
                  >
                    {NodeTypes[1].name}
                      <i
                        title={NodeTypes[1].description}
                        className="mx-2 fa fa-info-circle"
                      />
                  </label>
                </div>
              )}
              </div>
            </div>
            <div className="alert-danger mt-4 rounded text-center">
              <p
                className="text-danger  py-2"
                style={{ display: 'none' }}
                id="etag"
              >
                error
              </p>
            </div>
          </div>
          <div
            className="col-xl-4 col-lg-4 col-sm-6 col-md-4"
            style={{ marginTop: '16%' }}
          >
            <div className="mb-4 subcriptioninput">
              <label
                htmlFor="monthly-cost"
                className="form-label mb-2"
                style={{ fontWeight: 700 }}
              >
                Per Node Monthly Cost (USD)
              </label>
              <Inputbox
                type="text"
                className="form-control"
                id="monthly-cost"
                aria-describedby="emailHelp"
                value={`$ ${nodeCost}`}
                disabled
              />
            </div>
            <div className="mb-4 subcriptioninput">
              <label
                htmlFor="num-nodes"
                className="form-label mb-2"
                style={{ fontWeight: 700 }}
              >
                Enter Number of Nodes
              </label>
              <div className="input-group">
                <Inputbox
                  type="number"
                  className="form-control rounded-start"
                  style={{ borderRadius: '8px 0px 0px 8px !important' }}
                  value={nodeCount}
                  id="num-nodes"
                  min={1}
                  onChange={(e: { target: { value: string; }; }) => nodeCountHandler(e.target.value)}
                />
                <span
                  className="input-group-text cursor"
                  style={{ borderRadius: '0px 8px 8px 0px !important' }}
                >
                  Nodes
                </span>
              </div>
            </div>
            <div className="mb-4 subcriptioninput">
              <label
                htmlFor="total-cost"
                className="form-label mb-2"
                style={{ fontWeight: 700 }}
              >
                Total Monthly Cost (USD)
              </label>
              <input
                type="text"
                className="form-control"
                id="total-cost"
                aria-describedby="emailHelp"
                value={`$ ${totalCost}`}
                disabled
              />
            </div>
            <div className="row mt-3 mb-5">
              <div className="mx-1 col-5">
                <Button
                  type="button"
                  disabled={btnDisable}
                  className="btn btn-success rounded"
                  onClick={() => {
                    buyPlan();
                  }}
                >
                  Subscribe
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        title="Purchasing Polkadot"
        visibleFooter
        visibleFooterCloseButton
        visibleHeaderCloseIcon={false}
        visibleConfirmBtn={redirectionUrl !== ''}
        confirmBtnText="Continue"
        onConfirm={continueNext}
        confirmBtnClassName=""
      >
        <p className="status text-center pt-3">{purchaseResMsg}</p>
      </Modal>
    </section>
  );
};

export default DedicatedNodeBody;
